import { WR } from '../constants/measure';
import { QUESTIONS } from '../constants/assessmentItemType';
import { WR_FETCH_RETRY } from '../common/api/apiRetryGetConstants';

import selectors from '../rootSelectors';
import { saveMeasureResponse, fetchContent } from '../common/api/decActions';
import { blockScreen, deactivateNextButton, unblockScreen } from '../common/screen/screenActions';
import { resetQuestionsAndTimeTrackingState } from '../common/questions/questionsActions';
import { setPlaylistItemCompleted } from '../common/playlist/playlistActions';
import { goToInterstitial, goToQuestion } from '../common/navigation/navigationActions';
import { narrateReset } from '../common/audio/audioActions';
import { stopQuestionTimeTracking } from '../common/timeTracking/timeTrackingActions';

export const SET_WR_CONTENT = 'SET_WR_CONTENT';

export const setWRContent = (content) => ({
    type: SET_WR_CONTENT,
    content,
});

export const fetchWRContent = () => async (dispatch) => {
    const content = await dispatch(fetchContent(WR.MEASURE, WR_FETCH_RETRY));
    if (content) dispatch(setWRContent(content));
};

export const saveWRResponse = (questionIndex, duration) => (dispatch, getStore) => {
    const state = getStore();

    const formId = selectors.getWRFormId(state);
    const question = selectors.getWRContent(state, QUESTIONS, questionIndex - 1);
    const selectedResponseIndex = selectors.getSelectedIndex(state);
    const responseId = question.possibleResponses[selectedResponseIndex].id;

    const resultResponse = {
        time_duration: duration,
        response_id: responseId,
        item_id: question.itemId,
    };

    return dispatch(
        saveMeasureResponse(
            WR.MEASURE,
            formId,
            resultResponse,
            selectors.isWRMeasureCompleted(state, questionIndex),
        ),
    );
};

export const continueWRAssessment = (questionIndex) => async (dispatch, getStore) => {
    dispatch(blockScreen());
    dispatch(stopQuestionTimeTracking());

    const duration = selectors.getQuestionTimeTrackingDuration(getStore());
    const isComplete = await dispatch(saveWRResponse(questionIndex, duration));

    dispatch(unblockScreen());

    if (isComplete) {
        dispatch(setPlaylistItemCompleted(WR.KEY));
        dispatch(goToInterstitial());
    } else {
        dispatch(goToQuestion(WR.KEY, null, questionIndex + 1));
        dispatch(narrateReset());
        dispatch(deactivateNextButton());
        dispatch(resetQuestionsAndTimeTrackingState());
    }
};
